import React from 'react'

const MitigationEffectRadio = ({ list, groupName, value, onChange }) => {
  return (
    <div className="space-y-4 w-[300px]">
      <div className="flex flex-col items-baseline space-y-1 justify-between">
        {list.map((level, index) => (
          <label
            key={index}
            className="flex items-center justify-between cursor-pointer"
          >
            <div className="flex gap-1 justify-between w-full items-center">
              <input
                type="radio"
                name={groupName}
                value={level}
                checked={value === level}
                onChange={() => onChange(level)}
                className="w-5 h-5 accent-purple-600"
              />

              <span className="capitalize text-lg font-semibold text-gray-500">
                {level}
              </span>

            </div>
          </label>
        ))}
      </div>
    </div>
  );
};


export default MitigationEffectRadio